__turbopack_context__.v({
  "button": "styles-module-scss-module__SNZanW__button",
  "dots": "styles-module-scss-module__SNZanW__dots",
  "faqContainer": "styles-module-scss-module__SNZanW__faqContainer",
  "faqWrapper": "styles-module-scss-module__SNZanW__faqWrapper",
  "headerWrapper": "styles-module-scss-module__SNZanW__headerWrapper",
  "imgLabelClassName": "styles-module-scss-module__SNZanW__imgLabelClassName",
  "introContainer": "styles-module-scss-module__SNZanW__introContainer",
  "mainContainer": "styles-module-scss-module__SNZanW__mainContainer",
  "mainSectionContainer": "styles-module-scss-module__SNZanW__mainSectionContainer",
  "section": "styles-module-scss-module__SNZanW__section",
  "sectionHeaderTitle": "styles-module-scss-module__SNZanW__sectionHeaderTitle",
  "slidersWrapper": "styles-module-scss-module__SNZanW__slidersWrapper",
});
